"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.safeSetInterval = safeSetInterval;
exports.safeSetTimeout = safeSetTimeout;
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/**
 * Wrapper around setTimout which (in node) unrefs the returned timer to avoid
 * wedging the process open unexpectedly.
 * @param {Mixed} args
 * @protected
 * @returns {Timer|Number}
 */
function safeSetTimeout() {
  var timer = setTimeout.apply(void 0, arguments);
  if (timer.unref) {
    timer.unref();
  }
  return timer;
}

/**
 * Wrapper around setTimout which (in node) unrefs the returned timer to avoid
 * wedging the process open unexpectedly.
 * @param {Mixed} args
 * @protected
 * @returns {Timer|Number}
 */
function safeSetInterval() {
  var interval = setInterval.apply(void 0, arguments);
  if (interval.unref) {
    interval.unref();
  }
  return interval;
}
//# sourceMappingURL=index.js.map
